import { service } from "@ember/service";
import { Ability } from "ember-can";
import type { HomePageAlertType } from "parog-web/models/alert-triggered-journal-event";
import type SemeiaSessionService from "parog-web/services/session";
import { isClinicalForgetAlert } from "parog-web/utils/alert";

/**
 * This is the abilities to see the alerts which are triggered.
 */
// Something in ember-can seems to be preventing us to extend the Ability class
// with ES6 class syntax. I need to investigate a bit more to understand where this comes from
export default class AlertTriggeredJournalEventAbility extends Ability {
  @service declare session: SemeiaSessionService;

  declare model: HomePageAlertType | undefined;

  get canList(): boolean {
    const isDisabledForMedic =
      this.model &&
      isClinicalForgetAlert(this.model) &&
      this.session.medic &&
      this.session.medic.disabledAlertTypes?.includes(
        this.model?.triggeringJournalEventType || ""
      );

    return !isDisabledForMedic;
  }
}
